import { createFileRoute } from "@tanstack/react-router";

import DayOfWeekPage from "@/admin/reports/day-of-week/page";

export const Route = createFileRoute("/app/$storeId/reports/day-of-week")({
    component: RouteComponent,
});

function RouteComponent() {
    return <DayOfWeekPage />;
}
